export type Routes = '/' | '/unsubscribe';
export type ApplicationType = 'blog' | 'news';

export enum Status {
	NOT_OK = -1,
	OK = 0,
	NEW = 1,
	UPDATED = 2,
	CANCELED = 3
}

export interface IKeyword {
	id: string;
	type: string;
	name: string;
	selected: boolean;
}

export interface IStatus {
	code: Status;
	messages: Record<Status, string>;
	loading: boolean;
}

export interface IUnscubscribe {
	text: string;
	buttonText: string;
	unsubscribeUrl: string;
	unsubscribedUrl: string;
}

export interface IConfig {
	fcSiteId: string;
	subscribeUrl: string;
	toc: string;
	gdpr: string;
	unsubscribe: IUnscubscribe;
	type: ApplicationType;
	email?: string;
}

export interface IState {
	keywords: IKeyword[];
	status: IStatus;
	config: IConfig;
	route: Routes;
}


const deafultState: IState = {
	keywords: [],
	status: {
		code: Status.OK,
		loading: false,
		messages: {
			[Status.NOT_OK]: '',
			[Status.OK]: '',
			[Status.NEW]: '',
			[Status.UPDATED]: '',
			[Status.CANCELED]: ''
		}
	},
	config: {
		fcSiteId: '',
		type: 'news',
		subscribeUrl: '',
		toc: '',
		gdpr: '',
		unsubscribe: {
			buttonText: '',
			text: '',
			unsubscribeUrl: '',
			unsubscribedUrl: '',
		}
	},
	route: '/'
}

export default deafultState;
